import * as React from 'react';
import { t } from '../helper/locale';
import * as connectIcon from '../assets/images/connect-icon.svg';
import * as iconAlert from '../assets/images/icon-alert.svg';
import Icon from './Icon';
import { ActionButton } from './ActionButton';
import { ButtonStatus } from '../types/onboarding';
import { getSetupIntentTimeout } from '../constants';
import { registerExtensionConfiguredListener } from '../actions/onboardingActions';
import { identifyUserIfConfigured } from '../actions/trackingActions';
import { AlertBox } from 'styleguide-react';

export const ConnectCard: React.FunctionComponent<{
  url: string;
  initialButtonStatus: ButtonStatus;
  isConnected: () => Promise<boolean>;
  onSuccessNavigation: () => void;
}> = ({ url, isConnected, initialButtonStatus, onSuccessNavigation }) => {
  let timeoutRef: ReturnType<typeof setTimeout>;
  const [buttonStatus, setButtonStatus] = React.useState(initialButtonStatus);

  React.useEffect(
    () =>
      registerExtensionConfiguredListener(() => {
        clearTimeout(timeoutRef);
        setButtonStatus(ButtonStatus.SUCCESS);
        identifyUserIfConfigured().then(onSuccessNavigation);
      }),
    []
  );

  const checkButtonStatus = () => {
    setButtonStatus(ButtonStatus.LOADING);

    timeoutRef = setTimeout(async () => {
      const statusConnected = await isConnected();
      if (statusConnected) {
        setButtonStatus(ButtonStatus.SUCCESS);
        onSuccessNavigation();
      } else {
        setButtonStatus(ButtonStatus.ERROR);
      }
    }, getSetupIntentTimeout());
  };

  return (
    <div className="ConnectCard">
      {buttonStatus === ButtonStatus.ERROR && (
        <AlertBox className="ConnectCard__alert Alert">
          <Icon className="Alert__icon" path={iconAlert} />
          <span>
            {t('Something went wrong.')} {t('Please try again.')}
          </span>
        </AlertBox>
      )}
      <Icon className="ConnectCard__icon" path={connectIcon} />

      <div className="ConnectCard__instructions Instructions">
        <h1>{t('Let’s complete protection!')}</h1>
        <p className="Instructions__text">
          {t(
            'Next, we need to connect the Qustodio Chrome Extension to the Qustodio App.'
          )}

          <span className="Instructions__text--compact">
            {t(
              'Remember the app must be installed and configured on this Chromebook to continue.'
            )}
          </span>
        </p>
      </div>

      <ActionButton
        url={url}
        buttonStatus={buttonStatus}
        clickHandler={checkButtonStatus}
      />
    </div>
  );
};
